import { useState, ChangeEvent, useEffect } from 'react';
import { useIntl, IntlShape } from 'react-intl';
import { messages } from '../messages';
import { StyledInterCompanyPostingDesc } from './styled';

export const InterCompanyPostingDescription = ({
  setPostingDesc,
  postingDescription,
  isPostingDescriptionRequired
}: {
  setPostingDesc: (value: string) => void;
  postingDescription: string;
  isPostingDescriptionRequired: boolean | undefined;
}): React.JSX.Element => {
  const intl: IntlShape = useIntl();
  const [postingDescriptionFlag] = useState<boolean>(true);
  const [hasPostingDescError, setPostingDescError] = useState<boolean>(
    isPostingDescriptionRequired || true
  );

  const validateDesc = (desc: string) => {
    const isInValid = desc === '' && postingDescriptionFlag;
    setPostingDescError(isInValid);
    return !isInValid;
  };

  const handlePostingDesChange = (event: ChangeEvent<HTMLInputElement>) => {
    setPostingDesc(event.target?.value);
    validateDesc(event.target?.value);
  };

  useEffect(() => {
    if (!isPostingDescriptionRequired) {
      setPostingDescError(false);
    } else if (isPostingDescriptionRequired && postingDescription === '') {
      setPostingDescError(true);
    } else if (isPostingDescriptionRequired && postingDescription !== '') {
      setPostingDescError(false);
    }
  }, [
    postingDescriptionFlag,
    postingDescription,
    isPostingDescriptionRequired
  ]);

  return (
    <StyledInterCompanyPostingDesc
      data-testid="input-PostingDescription"
      isRequired={isPostingDescriptionRequired}
      label={intl.formatMessage(messages.postingDescription)}
      name="input-error"
      onChange={handlePostingDesChange}
      placeholder={intl.formatMessage(messages.postingDescriptionPlaceholder)}
      value={postingDescription}
      errorMessage={intl.formatMessage(messages.postingDescriptionErrorMessage)}
      hasError={hasPostingDescError}
      enableCustomValidation
      onError={(errors: string) => {
        setPostingDescError(errors.length > 0);
      }}
    />
  );
};
